import React, { useState, useEffect } from 'react';
import './Terms.css';



const Terms = () => {

  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const storedValue = localStorage.getItem("termsAccepted");
    if (storedValue === "true") {
      setAccepted(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("termsAccepted", "true");
    setAccepted(true);
  };

  return (
    <div className="terms">

      <div className="terms-hero">
        <div className="container">
          <h1 className="terms-title">Terms of Service</h1>
          <p className="terms-subtitle">
            Please read these terms carefully before using our services
          </p>
        </div>
      </div>

      <section className="terms-content section">
        <div className="container">

          <p className="last-updated">Last Updated: January 2026</p>

          <div className="terms-block">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using the services provided by LogicSphere Technologies,
              you acknowledge that you have read, understood, and agree to be bound
              by these Terms of Service. Your use of the services constitutes your
              acceptance of the terms and conditions set forth in this agreement. If
              you do not agree with any part of these terms, you should immediately
              discontinue using our services. These Terms govern all aspects of your
              relationship with LogicSphere Technologies.
            </p>
          </div>

          <div className="terms-block">
            <h2>2. Description of Services</h2>
            <p>
              LogicSphere Technologies offers a broad range of IT solutions including
              custom software development, web and mobile applications, cloud solutions,
              UI/UX design, and ongoing support services. Services are delivered with
              professional standards and may include additional documentation or
              terms specific to each engagement. We reserve the right to modify or
              discontinue any service without prior notice. All services provided are
              subject to compliance with these Terms and any applicable policies.
            </p>
          </div>

          <div className="terms-block">
            <h2>3. User Obligations and Conduct</h2>
            <p>
              As a user of our services, you agree to provide accurate, complete, and
              up-to-date information when required. You must not misuse the services,
              attempt unauthorized access, interfere with other users, or engage in
              any activity that could harm our systems or reputation. Unlawful
              activities, including intellectual property infringement and hacking
              attempts, are strictly prohibited. LogicSphere Technologies reserves
              the right to terminate access for any violation of these obligations.
            </p>
          </div>

          <div className="terms-block">
            <h2>4. Intellectual Property Rights</h2>
            <p>
              All content, designs, graphics, logos, software code, and materials
              published or displayed on the website or provided as part of our
              services are the exclusive property of LogicSphere Technologies or its
              licensors. You agree not to copy, modify, distribute, or reproduce
              content without our express written permission. Any unauthorized use
              of intellectual property may result in legal action. You retain rights
              to your own data but grant us a limited license to use it for service
              delivery as necessary.
            </p>
          </div>

          <div className="terms-block">
            <h2>5. Payment Terms</h2>
            <p>
              Payment for services will be governed by separate agreements or
              purchase orders between you and LogicSphere Technologies. Fees may be
              based on milestones, subscriptions, or hourly rates as agreed. Payment
              must be made in the currency and within the timeframe specified in the
              contract. Late or incomplete payments may result in suspension of
              services. Any refunds or adjustments will be handled in accordance
              with contract terms.
            </p>
          </div>

          <div className="terms-block">
            <h2>6. Privacy and Data Protection</h2>
            <p>
              We respect your privacy and handle personal information in accordance
              with our Privacy Policy, which is incorporated into these Terms by
              reference. You understand and agree that your data may be collected,
              stored, and processed to deliver services effectively. We implement
              reasonable safeguards to protect your information but cannot guarantee
              absolute security. You are responsible for protecting your account
              credentials and notifying us of any unauthorized access.
            </p>
          </div>

          <div className="terms-block">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, LogicSphere Technologies will
              not be liable for indirect, incidental, special, or consequential
              damages arising from the use of our services or any interruption of
              service. Our total liability for any claim related to these Terms will
              not exceed the total amount paid by you for the service in question.
              This limitation applies regardless of legal theory, whether in
              contract, tort, or otherwise.
            </p>
          </div>

          <div className="terms-block">
            <h2>8. Third-Party Links and Content</h2>
            <p>
              Our website and services may contain links to third-party websites,
              products, or services that are not owned or controlled by LogicSphere
              Technologies. We do not endorse or assume responsibility for content,
              privacy practices, or policies of any third-party sites. Accessing any
              third-party links is at your own risk, and you should review their
              terms and policies independently.
            </p>
          </div>

          <div className="terms-block">
            <h2>9. Changes to Terms</h2>
            <p>
              LogicSphere Technologies reserves the right to update, modify, or
              replace these Terms at any time. Changes will be effective upon
              posting to the website with a revised “Last Updated” date. Your
              continued use of the services after any such changes indicates your
              acceptance of the new Terms. If you do not agree with the updated
              Terms, you should discontinue use immediately.
            </p>
          </div>

          <div className="terms-accept">
            {!accepted ? (
              <button className="terms-btn" onClick={handleAccept}>
                I Accept Terms
              </button>
            ) : (
              <div className="accepted-message">
                ✔ You have accepted the Terms of Service
              </div>
            )}
          </div>

        </div>
      </section>

    </div>
  );
};

export default Terms;
